import { render, staticRenderFns } from "./SQuesEighteen.vue?vue&type=template&id=d9fb9c8c&scoped=true&"
import script from "./SQuesEighteen.vue?vue&type=script&lang=js&"
export * from "./SQuesEighteen.vue?vue&type=script&lang=js&"
import style0 from "./SQuesEighteen.vue?vue&type=style&index=0&id=d9fb9c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fb9c8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
